import type { RuleHandler } from "../types";

const checkTimesAllowedToComplete: RuleHandler = (context, requirement) => {
  const {
    timesAllowedToCompletePerEvent,
    timesAllowedToCompletePerEventFilter: perEventFilter,
  } = requirement.userDrivenAttributes!;

  if (!perEventFilter || !timesAllowedToCompletePerEvent) return false;

  const currentUsages =
    context.allocation?.attributes?.eventIdUsages?.[
      context.selection.eventIds[0]
    ];

  if (currentUsages >= timesAllowedToCompletePerEvent) {
    return false;
  }
  return true;
};

export { checkTimesAllowedToComplete };
